import axios, { AxiosRequestConfig } from 'axios';
import { getLocalStorageItem } from '../utility/helper';
import { HEADER_KEYS } from '../utility/constants';

const axiosInstance = axios.create({
  baseURL: `${(window as any).BASE_URL}`
});

axiosInstance.interceptors.request.use(
  (axiosRequestConfig: AxiosRequestConfig) => {
    /** This is commented out because it causes errors with the Keycloak-related api calls
    const token = getLocalStorageItem('token');

    if (token) {
      axiosRequestConfig.headers!.Authorization = BEARER + token;
    }

    **/

    const token = getLocalStorageItem('token');
    if (token && (
        !axiosRequestConfig.url?.includes('/auth/login') ||
        !axiosRequestConfig.url?.includes('/auth/logout') ||
        !axiosRequestConfig.url?.includes('/auth/generateToken') ||
        !axiosRequestConfig.url?.includes('/auth/forgotPassword') ||
        !axiosRequestConfig.url?.includes('/notification/resetPassword') ||
        !axiosRequestConfig.url?.includes('/auth/users/user/findByEmail') ||
        !axiosRequestConfig.url?.includes('/auth/users/updateStatus') ||
        !axiosRequestConfig.url?.includes('/auth/createUser') ||
        !axiosRequestConfig.url?.includes('/auth/otp/verify') ||
        !axiosRequestConfig.url?.includes('/auth/checkPassword'))) {

      axiosRequestConfig.headers!.Authorization = `Bearer ${token}`;
    }

    if (axiosRequestConfig.headers) {
      axiosRequestConfig.headers[HEADER_KEYS.X_USER_ID] = getLocalStorageItem('uid');
    }

    return axiosRequestConfig;
  },
  (error) => {
    console.error('error : ', error.response);

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('error : ', error.response);

    /**
     * /auth/login, the Email OTP endpoints (verify and MFA enrollment) and /auth/checkPassword
     * all return 401 as a normal, expected in-flow result - wrong password, wrong code - not a
     * sign the current session has expired (none of these calls even carry a session token to
     * begin with). Force-logging the user out on those would be wrong: e.g. mistyping a password
     * on the sign-in form, or while enrolling MFA on someone else's profile, shouldn't kick the
     * admin out of their own session.
     */
    const isPreAuthEndpoint = error.config?.url?.includes('/auth/login')
      || error.config?.url?.includes('/auth/otp/')
      || error.config?.url?.includes('/auth/checkPassword');

    if (error.response.status === 401 && !isPreAuthEndpoint) {
      localStorage.clear();
      window.location.href = '/expired';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;